module.exports = __webpack_public_path__ + "img/license-red.aa093233.svg";